module.exports = __webpack_public_path__ + "8f9053ecc4110df2dbf2a9bcf976f0a3.png";